module.exports = __webpack_public_path__ + "media/videos/vendor_video-fc8968dfe1b8cc06d954dba362b6d859.mp4";